/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, answerSelect, answerError, centerAbsolutely, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED : ANSWER : IMAGE 1 : STYLES --------------- ++++++++++ */
export default theme => ({
	image1: {
		position: 'relative',
		zIndex: '3',
		'& .graphic': {
			// backgroundImage - dynamic, comes from component which comes from settings
			backgroundColor: theme.color.neutral.dark.swatch,
			backgroundPosition: '50% 50%',
			backgroundRepeat: 'no-repeat',
			backgroundSize: 'cover',
			borderRadius: '100%',
			cursor: 'pointer',
			display: 'inline-block',
			width: pxToEm(80),
			height: pxToEm(80),
			position: 'relative',
			// overflow: 'hidden',
			transition: 'background-image .2s linear 0s',
			'& img': {
				borderRadius: 'inherit',
				width: '100%',
				height: 'auto'
			},
			'& .imageindicator': {
				fontSize: '130%',
				extend: centerAbsolutely
			},
            '&.editable-true.selected-false.valid-false': {
            	extend: answerError.image
            },
			extend: answerSelect
		},
		'& .background': {
			background: 'rgba(255,255,255,0.30)', // removed in animations for selected answer (so we don't have overlapping backgrounds)
			display: 'block',
			position: 'absolute',
			zIndex: '1',
			width: '100%',
			height: pxToEm(30),
			transition: 'background .2s linear 0s',
			extend: answerSelect,
			borderRadius: pxToEm(25),
			margin: replacePXinStringWithEM('5px auto 0 auto'),
			'&.selected-false.valid-false, &.duplicate-true': {
				extend: answerError.text
			}
		},
		'& .desc': {
			background: 'rgba(255,255,255,0.30)',
			borderRadius: pxToEm(25),
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			margin: replacePXinStringWithEM('5px auto 0 auto'),
			// width: pxToEm(75), //'90%',
			width: '100%',
			height: pxToEm(30),
			cursor: 'text',
			extend: answerSelect,
			position: 'relative',
            '&.editable-true.selected-false.valid-false': {
                extend: answerError.text
            },
			'& .text': {
				fontFamily: 'Helvetica',
				fontSize: pxToEm(12),
				display: 'flex',
				alignItems:'center',
				height: 'auto',
				width:'100%',
				position: 'relative',
				zIndex: '2',
				cursor: 'text',
				wordBreak: 'break-all',
				'& .editabletext': {
					height: '100%',
					width:'100%'
				}
			}
		},
		'&:hover': {
			animationName: 'pulse',
            animationDelay: '0s',
            animationDuration: '.5s'
		}
	}
});
